import React from "react";
import "../CreateTicket/CreateTicket.scss";
import { FaPlus } from "react-icons/fa";
import { useState, useEffect } from "react";
import { CreateTicketPopup } from "../CreateTicketPopup/CreateTicketPopup";
import { FiTrash2 } from "react-icons/fi";
import { DeleteTicketPopup } from "../DeleteTicketPopup/DeleteTicketPopup";
import LeafletMap from "../LeafetMap/LeafetMap";
import LeafletMapCoordinates from "../LeafletMapCoordinates/LeafletMapCoordinates";
import { useNavigate } from "react-router-dom";
import { ExportToExcel } from "../ExportToExcel/ExportToExcel";
import {
  HiOutlineArrowNarrowUp,
  HiOutlineArrowNarrowDown,
} from "react-icons/hi";

export const CreateTicket = () => {
  const userToken = localStorage.getItem("userToken");
  const urlParams = new URLSearchParams(window.location.search);
  const projectID = urlParams.get("project_id");
  const [showModal, setShowModal] = useState(false);
  const [hasTickets, setHasTickets] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [edit, setEdit] = useState(0);
  const [isTicketCreate, setIsTicketCreate] = useState(false);
  const [isTicketUpdate, setIsTicketUpdate] = useState(false);
  const [isTicketDelete, setIsTicketDelete] = useState(false);
  const [isImageDelete, setIsImageDelete] = useState(false);
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [ticketIdToDelete, setTicketIdToDelete] = useState(null);
  const [layers, setLayers] = useState([]);
  const [layer, setLayer] = useState(null);
  const [mapCoordinates, setMapCoordinates] = useState([]);
  const [imageData, setImageData] = useState(null);
  const navigate = useNavigate();
  const [excelData, setExcelData] = useState([]);
  const fileName = "myfile";
  const [projectName, setProjectName] = useState("");
  const [searchTicket, setSearchTicket] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSort = (key, direction) => {
    setSortConfig({ key, direction });
  };

  const dateKeys = ["updated_at", "updated_by", "date", "created_date"];

  const filteredTickets = tickets
    .filter((ticket) => {
      const term = searchTicket.toLowerCase();
      return (
        ticket.title?.toLowerCase().includes(term) ||
        ticket.ticket_id?.toString().includes(term) ||
        ticket.assignee_name?.toLowerCase().includes(term)
      );
    })
    .sort((a, b) => {
      if (!sortConfig.key) return 0;

      let valA = a[sortConfig.key];
      let valB = b[sortConfig.key];

      if (dateKeys.includes(sortConfig.key)) {
        valA = new Date(valA);
        valB = new Date(valB);

        // Ako je Invalid Date, postavi na neku default vrednost
        if (isNaN(valA)) valA = new Date(0);
        if (isNaN(valB)) valB = new Date(0);
      }

      if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  console.log("citaj filteredTickets ", filteredTickets);

  useEffect(() => {
    if (projectID) {
      fetch(
        `https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/w/project-select_w.php?project_id=${projectID}`,
        {
          method: "GET",
          headers: {
            Token: userToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            throw new Error("Server je vratio status: " + response.status);
          }
        })
        .then((data) => {
          if (data.response) {
            const projectData = data.data;
            document.title = `Ciric documentation - ${projectData.project_name}`;
          } else {
            console.error(data.message);
          }
        })
        .catch((error) => {
          console.error("Greška prilikom dohvatanja podataka:", error);
        });
    } else {
      document.title = `Ciric documentation`;
    }
  }, [projectID]);

  useEffect(() => {
    if (projectID) {
      fetch(
        `https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/w/project-select_w.php?project_id=${projectID}`,
        {
          method: "GET",
          headers: {
            Token: userToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            throw new Error("Server je vratio status: " + response.status);
          }
        })
        .then((data) => {
          if (data.response) {
            const projectData = data.data;
            document.title = `Ciric documentation - ${projectData.project_name}`;
          } else {
            console.error(data.message);
          }
        })
        .catch((error) => {
          console.error("Greška prilikom dohvatanja podataka:", error);
        });
    } else {
      document.title = `Ciric documentation`;
    }
  }, [projectID]);

  useEffect(() => {
    if (!layer) {
      return;
    }
    const fetchLayerImage = async () => {
      try {
        const response = await fetch(
          `https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/w/project-layer-image-select_w.php?project_layer_id=${layer}`,
          {
            method: "GET",
            headers: {
              Token: userToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Not valid");
        }

        const data = await response.json();
        setImageData(data.data);
        console.log("image data", imageData);
      } catch (error) {
        console.error("Error fetching layer image:", error.message);
        return null;
      }
    };
    fetchLayerImage();
  }, [layer]);

  useEffect(() => {
    if (!projectID) {
      return;
    }
    const fetchProjectLayers = async () => {
      const endpoint = `https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/w/project-layers-select_w.php?project_id=${projectID}`;

      try {
        const response = await fetch(endpoint, {
          method: "GET",
          headers: {
            Token: userToken,
          },
        });

        const data = await response.json();

        if (data.response) {
          setLayers(data.data);
          console.log("sta je layers", layers);
        } else {
          console.error("Error fetching project layers:", data.message);
        }
      } catch (error) {
        console.error("Error fetching project layers:", error);
      }
    };

    fetchProjectLayers();
  }, [projectID]);

  useEffect(() => {
    console.log("sta je layers", layers);
  }, [layers]);

  useEffect(() => {
    if (!projectID) {
      return;
    }
    const fetchTickets = async () => {
      console.log("je l udje ovde");
      try {
        const response = await fetch(
          `https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/w/tickets-select_w.php?project_id=${projectID}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Token: userToken,
            },
          }
        );

        const data = await response.json();

        if (data.response && data.data.length > 0) {
          if (layer) {
            const ticketsData = data.data.filter(
              (ticket) => ticket.project_layer_id == layer
            );
            console.log("layer tiketi", ticketsData);
            setTickets(ticketsData);
            const coordinates = ticketsData.map((ticket) => ({
              x: ticket.x,
              y: ticket.y,
            }));

            console.log("Koordinate x i y:", coordinates);
            setMapCoordinates(coordinates);
            console.log("koordinate", mapCoordinates);
          } else {
            setTickets(data.data);
          }

          console.log("lista tiketa", tickets);
        } else {
        }
      } catch (error) {
        console.error("Error fetching tickets:", error.message);
      }
    };

    fetchTickets();

    if (isTicketDelete) {
      fetchTickets();
      setIsTicketDelete(false);
    }

    if (isImageDelete) {
      fetchTickets();
      setIsImageDelete(false);
    }

    if (isTicketCreate) {
      fetchTickets();
      setIsTicketCreate(false);
    }

    if (isTicketUpdate) {
      fetchTickets();
      setIsTicketUpdate(false);
    }
  }, [
    projectID,
    isTicketDelete,
    isTicketCreate,
    isImageDelete,
    layer,
    isTicketUpdate,
  ]);

  const handleRowClick = (ticketId) => {
    console.log("tiket id", ticketId);
    setSelectedTicketId(ticketId);
    setEdit(1);
    setShowModal(true);
  };

  const handleDeleteConfirmation = (ticketId) => {
    setTicketIdToDelete(ticketId);
    setShowDeletePopup(true);
  };
  const deleteTicket = async () => {
    try {
      if (ticketIdToDelete !== null) {
        const response = await fetch(
          "https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/w/ticket-delete_w.php",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Token: userToken,
            },
            body: JSON.stringify({
              ticket_id: ticketIdToDelete,
            }),
          }
        );

        const data = await response.json();

        if (response.ok) {
          console.log("Ticket deleted successfully");
          console.log(data);
        } else {
          console.error("Failed to delete ticket:", data.message);
        }
      }
    } catch (error) {
      console.error("Error deleting ticket:", error.message);
    } finally {
      setTicketIdToDelete(null);
      setShowDeletePopup(false);
      setIsTicketDelete(true);
    }
  };

  const handleCreateLink = () => {
    if (projectID) {
      const projectTicketsURL = `/view-project-tickets/${projectID}`;
      window.open(projectTicketsURL, "_blank");
    } else {
      alert("Molimo odaberite projekat pre nego što kreirate link.");
    }
  };

  const handleExportToPDF = () => {
    const baseUrl =
      "https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/pdf-report.php";

    const urlWithProjectId = layer
      ? `${baseUrl}?project_id=${projectID}&download=true&project_layer_id=${layer}`
      : `${baseUrl}?project_id=${projectID}&download=true`;

    const a = document.createElement("a");
    a.href = urlWithProjectId;
    a.target = "_blank";
    a.rel = "noopener noreferrer";

    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/w/tickets-measurements-select_w.php?project_id=${projectID}`,
          {
            headers: {
              Token: userToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const responseData = await response.json();
        setProjectName(responseData.data.project_name);
        setExcelData(responseData.data.tickets);
        console.log("excel", responseData.data.tickets);
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchData();
  }, [projectID]);

  console.log("sta citas ticket", filteredTickets);

  return (
    <div className="create-ticket">
      <div className="add-ticket-and-filter">
        <button onClick={() => setShowModal(true)}>
          {" "}
          <FaPlus />
          Create ticket
        </button>
        <input
          type="text"
          placeholder="Search..."
          value={searchTicket}
          onChange={(e) => setSearchTicket(e.target.value)}
        />

        <select
          id="layer"
          value={layer}
          onChange={(e) => setLayer(e.target.value)}
        >
          <option value="">Filter tickets by layer</option>
          {layers.map((layer) => (
            <option key={layer.project_layer_id} value={layer.project_layer_id}>
              {layer.layer_name}
            </option>
          ))}
        </select>
        <button onClick={handleCreateLink}>Create link</button>
        {excelData && (
          <ExportToExcel apiData={excelData} fileName={projectName} />
        )}
        <button onClick={handleExportToPDF}>Export to PDF</button>
      </div>

      {layer && imageData && mapCoordinates && !showModal && (
        <LeafletMapCoordinates
          imageUrl={imageData.img_url}
          imgHeight={imageData.img_height}
          imgWidth={imageData.img_width}
          pins={mapCoordinates}
          mapHeight="700px"
          mapWidth="1500px"
          enableDrag={false}
          tickets={tickets}
          setIsImageDelete={setIsImageDelete}
          handleRowClick={handleRowClick}
          user={1}
        />
      )}

      <div className="tickets-table">
        <table>
          <thead>
            <tr>
              {[
                { label: "Order number", key: "order_number" },
                { label: "ID", key: "ticket_id" },
                { label: "Zuständiger", key: "assignee_name" },
                { label: "Status", key: "ticket_status_title" },
                { label: "Empfänger", key: "receivers" },
                { label: "Titel", key: "title" },
                { label: "Autor", key: "author_name" },
                { label: "Aktualisiert am", key: "updated_date" },
                { label: "Aktualisiert von", key: "updated_name" },
                { label: "Datum", key: "created_date" },
              ].map(({ label, key }) => (
                <th key={key}>
                  {label}
                  <span className="sort-icons">
                    <HiOutlineArrowNarrowUp
                      className="sort-icon"
                      onClick={() => handleSort(key, "asc")}
                      style={{
                        cursor: "pointer",
                        color:
                          sortConfig.key === key &&
                          sortConfig.direction === "asc"
                            ? "#999"
                            : "#fff",
                        transform:
                          sortConfig.key === key &&
                          sortConfig.direction === "asc"
                            ? "scale(1.2)"
                            : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                    <HiOutlineArrowNarrowDown
                      className="sort-icon"
                      onClick={() => handleSort(key, "desc")}
                      style={{
                        cursor: "pointer",
                        color:
                          sortConfig.key === key &&
                          sortConfig.direction === "desc"
                            ? "#999" // aktivna strelica postaje siva
                            : "#fff", // default bela
                        transform:
                          sortConfig.key === key &&
                          sortConfig.direction === "desc"
                            ? "scale(1.2)"
                            : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  </span>
                </th>
              ))}
              <th></th>
            </tr>
          </thead>

          <tbody>
            {filteredTickets.length === 0 ? (
              <tr>
                <td colSpan="12">No tickets available</td>
              </tr>
            ) : (
              filteredTickets.map((ticket) => (
                <tr
                  key={ticket.ticket_id}
                  onClick={() => handleRowClick(ticket.ticket_id)}
                >
                  <td>{ticket.order_number}</td>
                  <td>{ticket.ticket_id}</td>
                  <td>{ticket.assignee_name}</td>
                  <td>{ticket.ticket_status_title}</td>
                  <td>{ticket.receivers}</td>
                  <td>{ticket.title}</td>
                  <td>{ticket.author_name}</td>
                  <td>{ticket.updated_date}</td>
                  <td>{ticket.updated_name || ""}</td>
                  <td>{ticket.created_date}</td>
                  <td>
                    <FiTrash2
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteConfirmation(ticket.ticket_id);
                      }}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {showModal && (
        <CreateTicketPopup
          onHide={() => {
            setShowModal(false);
            setSelectedTicketId(null);
            setEdit(0);
          }}
          selectedTicketId={selectedTicketId}
          edit={edit}
          setIsTicketCreate={setIsTicketCreate}
          setIsTicketUpdate={setIsTicketUpdate}
          filteredLayer={layer}
          user={1}
        />
      )}
      {showDeletePopup && (
        <DeleteTicketPopup
          show={showDeletePopup}
          onHide={() => setShowDeletePopup(false)}
          onDelete={deleteTicket}
        />
      )}
    </div>
  );
};
